export default "__VITE_ASSET__BR5MZnP___"